define("ember-arg-types/decorator", ["exports", "ember-arg-types/-private/is-element-descriptor", "ember-arg-types/-private/throw-console-error", "prop-types", "ember-get-config", "@ember/utils", "ember-arg-types/-private/closest-string"], function (_exports, _isElementDescriptor, _throwConsoleError, PropTypes, _emberGetConfig, _utils, _closestString) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = arg;
  _exports.forbidExtraArgs = forbidExtraArgs;
  0; //eaimeta@70e063a35619d71f0,"ember-arg-types/-private/is-element-descriptor",0,"ember-arg-types/-private/throw-console-error",0,"prop-types",0,"ember-get-config",0,"@ember/utils",0,"ember-arg-types/-private/closest-string",0,"@embroider/macros"eaimeta@70e063a35619d71f
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const REGISTERED_ARGS = Symbol('args');
  const INTERCEPT_CLASS = 'ForbidExtraArgsIntercept';
  function shouldThrowErrors() {
    const throwErrors = _emberGetConfig.default['ember-arg-types']?.throwErrors;
    return (0, _utils.isNone)(throwErrors) ? true : throwErrors;
  }
  function getClassName(instance) {
    return instance.constructor.name === INTERCEPT_CLASS // if the current class is this override
    ? Object.getPrototypeOf(instance.constructor).name // get parent class name
    : instance.constructor.name; // use current class name
  }
  function createGetter(target, key, descriptor, validator) {
    const defaultInitializer = descriptor.initializer || descriptor.get || (() => undefined);
    return {
      get() {
        const argValue = this.args[key];
        const returnValue = argValue !== undefined ? argValue : defaultInitializer.call(this);
        return returnValue;
      }
    };
  }
  function arg() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if ((0, _isElementDescriptor.default)(...args)) {
      return createGetter(...args);
    }
    const [validator] = args;
    return function argument() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return createGetter(...[...args, validator]);
    };
  }
  function forbidExtraArgs(target) {
    let returnClass = target;

    // only subclass in debug mode

    return returnClass;
  }
});